import { defineCustomElement as defineButton } from '@om-design-system/web-components/dist/components/omk-button';
import { defineCustomElement as defineCheckbox } from '@om-design-system/web-components/dist/components/omk-checkbox';
import { defineCustomElement as defineDivider } from '@om-design-system/web-components/dist/components/omk-divider';
import { defineCustomElement as defineIcon } from '@om-design-system/web-components/dist/components/omk-icon';
import { defineCustomElement as defineIconButton } from '@om-design-system/web-components/dist/components/omk-icon-button';
import { defineCustomElement as defineList } from '@om-design-system/web-components/dist/components/omk-list';
import { defineCustomElement as defineListItem } from '@om-design-system/web-components/dist/components/omk-list-item';
import { defineCustomElement as defineRadio } from '@om-design-system/web-components/dist/components/omk-radio';
import { defineCustomElement as defineSelect } from '@om-design-system/web-components/dist/components/omk-select';
import { defineCustomElement as defineSelectOption } from '@om-design-system/web-components/dist/components/omk-select-option';
import { defineCustomElement as defineTab } from '@om-design-system/web-components/dist/components/omk-tab';
import { defineCustomElement as defineTabs } from '@om-design-system/web-components/dist/components/omk-tabs';
import { defineCustomElement as defineTextField } from '@om-design-system/web-components/dist/components/omk-text-field';

function skipValidationUntilReady(tagName, isReady) {
  const { prototype } = customElements.get(tagName);
  const { validate } = prototype;
  prototype.validate = function (...args) {
    if (!isReady(this)) return Promise.resolve();
    return validate.apply(this, args);
  };
}

export default function defineOmDesignSystemElements() {
  [
    defineButton,
    defineCheckbox,
    defineDivider,
    defineIcon,
    defineIconButton,
    defineList,
    defineListItem,
    defineRadio,
    defineSelect,
    defineSelectOption,
    defineTab,
    defineTabs,
    defineTextField,
  ].forEach(define => define());
  skipValidationUntilReady('omk-checkbox', el => el.innerMaterialElement);
  skipValidationUntilReady('omk-text-field', el => el.materialTextField);
}
